export const assetStatus = {
  New: 'New',
  Holdover: 'Holdover',
  Expiring: 'Expiring',
  Recalled: 'Recalled',
}
